import { Alert, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { hideSnackBar, UiState } from 'src/api/ui-slice';

export function AppSnackBar() {

  const dispatch = useAppDispatch();
  const uiState: UiState = useAppSelector((state) => state.ui);

  const handleClose = (
      event?: React.SyntheticEvent | Event,
      reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(hideSnackBar());

  };
  const open = uiState.snackBarText != null;
  const autoHideDuration = uiState.snackBarSeverity === 'info' || uiState.snackBarSeverity === 'success' ? 5000 : null
  return (
      <Snackbar
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}
          open={open} autoHideDuration={autoHideDuration} onClose={handleClose}>
        <Alert
            onClose={handleClose}
            severity={uiState.snackBarSeverity}
            variant="filled"
            sx={{width: '100%'}}
        >
          {uiState.snackBarText}
        </Alert>
      </Snackbar>
  )
}